import { useTranslation } from 'react-i18next'

/*
 * Compact FR/EN/NL language switch for public & auth pages (the app uses the
 * topbar picker instead). Persists via i18next's localStorage detector.
 */
const LANGS = ['fr', 'en', 'nl']

export default function LanguageSwitch({ style }) {
  const { i18n } = useTranslation()
  const current = (i18n.resolvedLanguage || i18n.language || 'fr').slice(0, 2)
  return (
    <div style={{ display: 'inline-flex', gap: 2, padding: 3, background: '#fff', border: '1px solid var(--color-border)', borderRadius: 999, boxShadow: 'var(--shadow-card)', ...style }}>
      {LANGS.map((l) => {
        const on = l === current
        return (
          <button
            key={l}
            type="button"
            onClick={() => i18n.changeLanguage(l)}
            aria-pressed={on}
            style={{
              border: 'none', borderRadius: 999, padding: '6px 12px', fontSize: 12.5, fontWeight: 700,
              background: on ? 'var(--color-primary)' : 'transparent',
              color: on ? '#fff' : 'var(--color-text)', cursor: 'pointer',
            }}
          >
            {l.toUpperCase()}
          </button>
        )
      })}
    </div>
  )
}
